
import { FaIndianRupeeSign } from 'react-icons/fa6';

function Performance() {

  return (
    <div>
      <div className="incentive-cards-row">
        <div className="dark-stat-card">
          <span className="card-title-text">THIS WEEK INCENTIVE EARNED</span>
          <div className="card-top-header">
            <FaIndianRupeeSign className="custom-card-icon" size={15} />
            <div className="card-value-text">12,850/-</div>
          </div>
        </div>

        <div className="dark-stat-card">
          <span className="card-title-text">THIS MONTH INCENTIVE EARNED</span>
          <div className="card-top-header">
            <FaIndianRupeeSign className="custom-card-icon" size={15} />
            <div className="card-value-text">48,600/-</div>
          </div>
        </div>

      <div className="dark-stat-card">
        <span className="card-title-text">Leave Status</span>
        <div className="card-top-header">
        <div className="card-value-text">You have not apply for any leave</div>
        </div>
      </div>
    </div>
    </div>
  );
}

export default Performance;
